import React, { useEffect } from 'react';
import { Box } from '@razorpay/blade/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import { WizardHeader, WizardWrapper } from 'components/WizardViews/components';
import { useHistory, useLocation } from 'react-router-dom';
import { routePaths } from 'components/Routes/data';
import { useSearchParams } from 'hooks/useSearchParams';
import { redirectSafely } from 'utils/Urls';
import { AccountDetailsStep } from './AccountDetailsStep';
import { useFormWithProvider } from 'forms';
import { useUserId } from '../hooks/useUserId';
import { BankAccountFormData, PrefillLocationState } from './types';
import { bankFormDataInitialState } from '../data';
import { useGetBankAccountDetails } from '../hooks/useGetBankAccountDetails';

export const AddEditBankAccount = () => {
  const history = useHistory();
  const userId = useUserId();
  const { urlParams } = useSearchParams();
  const { setFormData } = useFormWithProvider<BankAccountFormData>();
  const returnTo = urlParams.get('returnTo');
  const { state: locationState } = useLocation<PrefillLocationState | undefined>();
  const prefill = locationState?.prefillBankAccount;

  const isPrefilled = !!(prefill?.accountNumber && prefill?.ifscCode);

  useEffect(() => {
    if (isPrefilled) {
      setFormData({
        accountNumber: prefill?.accountNumber ?? '',
        confirmAccountNumber: prefill?.accountNumber ?? '',
        ifscCode: prefill?.ifscCode ?? '',
      });
    }
    // Prefill once on mount from the navigation state (e.g. Retry Verification).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const employeeName =
    useGetBankAccountDetails().queryResponse.data?.data.meta?.employee_name ?? '';

  const moveToPreview = () => {
    if (returnTo) {
      redirectSafely(returnTo);
      return;
    }
    history.push({
      pathname: routePaths.employeeDetailsV2.bankAccountDetails.preview,
      search: `?userId=${userId}`,
    });
    setFormData(bankFormDataInitialState);
  };

  return (
    <WizardInfoProvider initialStep={1} totalSteps={1}>
      <WizardWrapper>
        <WizardHeader heading="Add" subHeading="Bank Account" onCloseClick={moveToPreview} />
        <Box width="100%" flex={1} overflowY="auto" height="100%">
          <AccountDetailsStep
            onBackClick={moveToPreview}
            onSuccess={moveToPreview}
            employeeName={employeeName}
            isPrefilled={isPrefilled}
          />
        </Box>
      </WizardWrapper>
    </WizardInfoProvider>
  );
};
